(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cv-design-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initGallery(gallery) {
      if (gallery.dataset.dshowInitialized === 'true') return;
      gallery.dataset.dshowInitialized = 'true';

      const viewer = gallery.querySelector('[data-dshow-viewer]');
      const counter = gallery.querySelector('[data-dshow-counter]');
      const prev = gallery.querySelector('[data-dshow-prev]');
      const next = gallery.querySelector('[data-dshow-next]');
      const slides = Array.from(gallery.querySelectorAll('.cv-dshow__slide'));
      if (slides.length === 0) return;

      function update(nextIndex) {
        const total = slides.length;
        const safe = ((nextIndex % total) + total) % total;
        gallery.dataset.currentIndex = safe;
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === safe));
        // Primeira imagem = repouso, sobreposta a frente. A partir da
        // segunda ha interacao e ela recua.
        if (gallery.dataset.insetBehind !== 'false') {
          gallery.classList.toggle('is-browsing', safe !== 0);
        }
        if (counter) counter.textContent = `Imagem ${safe + 1} de ${total}`;
      }

      function current() {
        return parseInt(gallery.dataset.currentIndex || '0', 10);
      }

      if (prev) prev.addEventListener('click', () => update(current() - 1));
      if (next) next.addEventListener('click', () => update(current() + 1));

      if (viewer) {
        viewer.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') { event.preventDefault(); update(current() - 1); }
          if (event.key === 'ArrowRight') { event.preventDefault(); update(current() + 1); }
        });
      }
    }

    function boot() {
      document.querySelectorAll('.cv-dshow [data-dshow-gallery]').forEach(initGallery);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cv-project-rows"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initGallery(gallery) {
      if (gallery.dataset.prowInitialized === 'true') return;
      gallery.dataset.prowInitialized = 'true';

      const viewer = gallery.querySelector('[data-prow-viewer]');
      const counter = gallery.querySelector('[data-prow-counter]');
      const prev = gallery.querySelector('[data-prow-prev]');
      const next = gallery.querySelector('[data-prow-next]');
      const slides = Array.from(gallery.querySelectorAll('.cv-prow__slide'));
      if (slides.length === 0) return;

      function update(nextIndex) {
        const total = slides.length;
        const safe = ((nextIndex % total) + total) % total;
        gallery.dataset.currentIndex = safe;
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === safe));
        if (counter) counter.textContent = `Imagem ${safe + 1} de ${total}`;
      }

      function current() {
        return parseInt(gallery.dataset.currentIndex || '0', 10);
      }

      if (prev) prev.addEventListener('click', () => update(current() - 1));
      if (next) next.addEventListener('click', () => update(current() + 1));

      // Setas do teclado apenas com o foco dentro do slideshow, para não roubar
      // a navegação da página — ao contrário do popup, que é modal.
      if (viewer) {
        viewer.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') { event.preventDefault(); update(current() - 1); }
          if (event.key === 'ArrowRight') { event.preventDefault(); update(current() + 1); }
        });
      }
    }

    function boot() {
      document.querySelectorAll('.cv-prow [data-prow-gallery]').forEach(initGallery);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cv-renas-landing"] && !Shopify.designMode) return;
  try {
    
  /*
    O slideshow do bloco de desenho. E o mesmo mecanismo da
    cv-design-showcase, reescrito aqui porque veio o desenho e nao a
    seccao: assim esta pagina nao depende de outra estar carregada.

    Sem JavaScript fica a primeira fotografia a vista — que e o essencial.
  */
  (() => {
    function iniciar(galeria) {
      if (galeria.dataset.renasPronta === 'true') return;
      galeria.dataset.renasPronta = 'true';

      const viewer = galeria.querySelector('[data-renas-viewer]');
      const contador = galeria.querySelector('[data-renas-contador]');
      const ant = galeria.querySelector('[data-renas-ant]');
      const seg = galeria.querySelector('[data-renas-seg]');
      const slides = Array.from(galeria.querySelectorAll('.cv-renas__slide'));
      if (slides.length === 0) return;

      function mostrar(indice) {
        const total = slides.length;
        const i = ((indice % total) + total) % total;
        galeria.dataset.indice = i;
        slides.forEach((slide, n) => slide.classList.toggle('is-active', n === i));
        // Primeira imagem = repouso, a do canto fica a frente. A partir
        // da segunda ha interaccao e ela recua.
        galeria.classList.toggle('is-browsing', i !== 0);
        if (contador) contador.textContent = `Imagem ${i + 1} de ${total}`;
      }

      const actual = () => parseInt(galeria.dataset.indice || '0', 10);

      if (ant) ant.addEventListener('click', () => mostrar(actual() - 1));
      if (seg) seg.addEventListener('click', () => mostrar(actual() + 1));
      if (viewer) {
        viewer.addEventListener('keydown', (evento) => {
          if (evento.key === 'ArrowLeft') { evento.preventDefault(); mostrar(actual() - 1); }
          if (evento.key === 'ArrowRight') { evento.preventDefault(); mostrar(actual() + 1); }
        });
      }
    }

    /*
      A escada d'«O essencial». Um observador diz quando a lista entra no
      ecra; a partir dai cada linha sobe com 95ms de atraso sobre a
      anterior. A classe is-escada e posta AQUI e nao no HTML de
      proposito: e ela que esconde as linhas, por isso sem JavaScript —
      ou se isto falhar — a lista aparece inteira e legivel.
    */
    function escada(lista) {
      if (lista.dataset.escadaPronta === 'true') return;
      lista.dataset.escadaPronta = 'true';

      const quieto = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (quieto.matches || !('IntersectionObserver' in window)) return;

      lista.classList.add('is-escada');
      const observador = new IntersectionObserver((entradas) => {
        entradas.forEach((entrada) => {
          if (!entrada.isIntersecting) return;
          entrada.target.classList.add('is-dentro');
          observador.unobserve(entrada.target);
        });
      }, { threshold: 0.12 });
      observador.observe(lista);
    }

    function arrancar() {
      document.querySelectorAll('.cv-renas [data-renas-galeria]').forEach(iniciar);
      document.querySelectorAll('.cv-renas [data-escada]').forEach(escada);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', arrancar, { once: true });
    } else {
      arrancar();
    }
    document.addEventListener('shopify:section:load', arrancar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-gallery-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = '.cv-project-gallery[data-section-id]';

    function initProjectGallery(section) {
      if (!section || section.dataset.galleryInitialized === 'true') return;
      section.dataset.galleryInitialized = 'true';

      const body = document.body;
      const sliderTrack = section.querySelector('[data-project-gallery-track]');
      const progressFill = section.querySelector('.cv-project-gallery__progress-fill');
      const openButtons = section.querySelectorAll('[data-project-open]');
      const modals = section.querySelectorAll('[data-project-modal]');

      function updateSliderProgress() {
        if (!sliderTrack || !progressFill) return;

        const maxScroll = sliderTrack.scrollWidth - sliderTrack.clientWidth;

        if (maxScroll <= 0) {
          progressFill.style.width = '100%';
          return;
        }

        const progress = (sliderTrack.scrollLeft / maxScroll) * 100;
        progressFill.style.width = `${progress}%`;
      }

      function getModal(index) {
        return section.querySelector(`[data-project-modal="${index}"]`);
      }

      function getSlides(modal) {
        return Array.from(modal.querySelectorAll('.cv-project-gallery__slide'));
      }

      function updateModal(modal, nextIndex) {
        const slides = getSlides(modal);
        if (!slides.length) return;

        const safeIndex = Math.max(0, Math.min(nextIndex, slides.length - 1));
        modal.dataset.currentIndex = safeIndex;

        slides.forEach((slide, index) => {
          slide.classList.toggle('is-active', index === safeIndex);
        });

        const counter = modal.querySelector('.cv-project-gallery__counter');
        if (counter) {
          counter.textContent = `Imagem ${safeIndex + 1} de ${slides.length}`;
        }

        const prevButton = modal.querySelector('[data-project-prev]');
        const nextButton = modal.querySelector('[data-project-next]');

        if (prevButton) {
          prevButton.disabled = slides.length <= 1;
          prevButton.classList.toggle('is-hidden', slides.length <= 1);
        }

        if (nextButton) {
          nextButton.disabled = slides.length <= 1;
          nextButton.classList.toggle('is-hidden', slides.length <= 1);
        }
      }

      function openModal(index) {
        const modal = getModal(index);
        if (!modal) return;

        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        modal.dataset.currentIndex = 0;
        body.classList.add('cv-project-gallery-is-open');

        updateModal(modal, 0);
      }

      function closeModal(modal) {
        if (!modal) return;

        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        body.classList.remove('cv-project-gallery-is-open');
      }

      openButtons.forEach((button) => {
        button.addEventListener('click', () => {
          openModal(button.dataset.projectOpen);
        });
      });

      modals.forEach((modal) => {
        modal.querySelectorAll('[data-project-close]').forEach((button) => {
          button.addEventListener('click', () => closeModal(modal));
        });

        const prevButton = modal.querySelector('[data-project-prev]');
        const nextButton = modal.querySelector('[data-project-next]');

        if (prevButton) {
          prevButton.addEventListener('click', () => {
            const currentIndex = parseInt(modal.dataset.currentIndex || '0', 10);
            const slides = getSlides(modal);
            const nextIndex = currentIndex <= 0 ? slides.length - 1 : currentIndex - 1;
            updateModal(modal, nextIndex);
          });
        }

        if (nextButton) {
          nextButton.addEventListener('click', () => {
            const currentIndex = parseInt(modal.dataset.currentIndex || '0', 10);
            const slides = getSlides(modal);
            const nextIndex = currentIndex >= slides.length - 1 ? 0 : currentIndex + 1;
            updateModal(modal, nextIndex);
          });
        }
      });

      document.addEventListener('keydown', (event) => {
        const activeModal = section.querySelector('.cv-project-gallery__modal:not([hidden])');
        if (!activeModal) return;

        if (event.key === 'Escape') {
          closeModal(activeModal);
          return;
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          activeModal.querySelector('[data-project-prev]')?.click();
          return;
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          activeModal.querySelector('[data-project-next]')?.click();
        }
      });

      if (sliderTrack) {
        updateSliderProgress();
        sliderTrack.addEventListener('scroll', updateSliderProgress, { passive: true });
        window.addEventListener('resize', updateSliderProgress);
      }
    }

    function bootProjectGallery() {
      document.querySelectorAll(sectionSelector).forEach(initProjectGallery);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootProjectGallery, { once: true });
    } else {
      bootProjectGallery();
    }

    document.addEventListener('shopify:section:load', bootProjectGallery);
  })();

  } catch(e) { console.error(e); }
})();
})();
